import { useAuth0 } from "@auth0/auth0-react";
import { useApolloClient } from "@apollo/client";
import React from "react";
import { AccountContext } from "@app.automotus.io/components/context/AccountContext";

export function useLogout(): LogoutFunc {
  const { logout: auth0Logout } = useAuth0();
  const client = useApolloClient();
  // Consume the context directly (not the throwing hook) so this works when
  // AccountContextProvider is not mounted (e.g. CurbPass). The DEFAULT_ACCOUNT_CONTEXT
  // sentinel's clearAccountContext is a no-op, so calling it is always safe.
  const { clearAccountContext } = React.useContext(AccountContext);

  return async () => {
    client.stop();
    await client.resetStore();
    clearAccountContext();
    localStorage.removeItem("activePayeeAccountId");
    auth0Logout({ returnTo: `${window.location.origin}/login` });
  };
}

export type LogoutFunc = () => Promise<void>;

export default useLogout;
